'use strict';

function calcDistance(startX, startY, endX, endY) {
	return Math.sqrt(
		Math.pow(startX - endX, 2) +
		Math.pow(startY - endY, 2)
	);
}

module.exports = calcDistance;